import { useNavigateToRoute } from '@lib/navigation';
import { UseNavigateToRouteReturn } from '@lib/navigation/hooks/useNavigateToRoute';

import { MAIN } from '.';

export const useNavigateToMain = (): UseNavigateToRouteReturn =>
  useNavigateToRoute(MAIN);
